var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNounArrowArrowsDownArrow1807797(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.482,
    height: 29.675,
    viewBox: "0 0 21.482 29.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-arrow-arrows-down-arrow-1807797",
    transform: "translate(-232.438 -117.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M243.177,147.275a1.1,1.1,0,0,0,.7-.272l9.721-9.21a1.03,1.03,0,0,0,.04-1.447,1.063,1.063,0,0,0-1.447-.04l-7.994,7.563V118.623a1.023,1.023,0,1,0-2.046,0v25.246l-7.994-7.563a1.078,1.078,0,0,0-1.447.04,1.038,1.038,0,0,0,.04,1.447l9.721,9.21a.936.936,0,0,0,.7.272Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounArrowArrowsDownArrow1807797);
export default __webpack_public_path__ + "static/media/noun-arrow-arrows-down-arrow-1807797.f5adb0bca8a7820ee6e4b5c9ba0ad23b.svg";
export { ForwardRef as ReactComponent };